// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3tbrq","footer-controls":"Footer_footer-controls__36R7i","checkout-button":"Footer_checkout-button__PE0nk"};